import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

const AuthRedirectHandler: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    const handleRedirect = async () => {
      const hash = window.location.hash;
      if (!hash) return;

      const params = new URLSearchParams(hash.substring(1));
      const access_token = params.get('access_token');
      const refresh_token = params.get('refresh_token');
      const type = params.get('type');

      console.log('[RedirectHandler] type:', type);
      console.log('[RedirectHandler] token:', access_token);

      if (access_token && type === 'recovery') {
        try {
          setProcessing(true);

          const { error } = await supabase.auth.setSession({
            access_token,
            refresh_token: refresh_token || '',
          });

          if (error) {
            console.error('[RedirectHandler] setSession error:', error.message);
            navigate('/');
            return;
          }

          navigate('/reset-password', { replace: true });
        } catch (err) {
          console.error('[RedirectHandler] unexpected error:', err);
          navigate('/');
        } finally {
          setProcessing(false);
        }
      }
    };

    handleRedirect();
  }, [location]);

  if (processing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-purple-50">
        <div className="text-center text-purple-700 text-xl font-bold animate-pulse">
          Loading...
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthRedirectHandler;
